import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from "react-router-dom";

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Login from './login/login'
import Dashboard from './dashboard/dashboard';
import $ from "jquery";
import Usercontroller from "./user/usercontroller";
import Staffcontroller from "./staff/staffcontroller";
import Settingscontroller from './settings/settingscontrolller';
import Joblist from './jobs/joblist';
import AddStaff from './staff/addstaff';
import Editstaff from './staff/editstaff';
import Branchlist from './Regions&Branches/Branchlist.js';
import Jobposting from './jobs/addjobposting';
import Editjobposting from './jobs/editjobposting';
import AddBranch from './Regions&Branches/AddBranch.js';
import Editbranch from './Regions&Branches/branchedit';
import Summernote from './staff/summernote';
import Leavelist from './leaveapplication/listleave';
import MyLeavelist from './leaveapplication/myleaveapplication';
import LeaveSettings from './leaveapplication/leavesettings';
import AddLeaveSettings from './leaveapplication/addleavesettings';
import HolidayCalender from './shift/shift.js';
import LeavePolicy from './leaveapplication/leavepolicy.js';
import AddLeavePolicy from './leaveapplication/addleavepolicy.js';
import EditLeavePolicy from './leaveapplication/editleavepolicy.js';
import Leaveassignment from './leaveapplication/leaveassignment.js';
import Leaveassignmentlist from './leaveapplication/leaveassignmentlist.js';
import EditLeaveassignment from './leaveapplication/leaveassignmentedit.js'

import Leaveapply from './LeaveApply/leaveapply.js';
import Leaveapplyadd from './LeaveApply/leaveapplyadd.js';
import EmailRestAPI from './components/EmailRestAPI.jsx';
import Leaveapproves from './leaveapplication/leaveapproves.js';
import Leavecontrolpanel from './leaveapplication/leavecontrolpanel.js';
import Leavelevelsetup from './leaveapplication/leavelevelsetup.js';
import Shiftlist from './Shiftdetails/shifttlist.js';
import Shiftreq from './shift/shiftreq.js';
import Shiftaprvl from './shift/shiftaprvl.js';
import Departmentlist from './departments/departmentlist.js';
import Deptposting from './departments/adddepartment.js';
import Editdepartment from './departments/editdepartment.js';
import Shiftassignment from './Shiftdetails/shiftassignment.js';
import Editshiftassignment from './Shiftdetails/editshiftassignment.js';
import AutoLogout from './autologout.js';
import Editinterassignment from './Shiftdetails/editinterassignment.js';
import Editintraassignment from './Shiftdetails/editintraassignment.js';
import Programs from './user/programs.js';
import Adddailyshift from './Shiftdetails/adddailyshift.js';
import Menu from './user/menu.js';
import Unauthorized from './unauthorized.js';
import Shifttool from "./shift/shifttool.js";
import Addintershift from "./Shiftdetails/addintershift.js";
import Addintrashift from "./Shiftdetails/addintrashift.js";
import Attendancelist from './attendance/attendance.js';
import Holidays from './holidays/holidays.js';
import Punchly from './punchlymodule/punchly.js';
import FaceKiosk from './punchlymodule/FaceKiosk.js';
import AttendanceReport from './attendance/report.js';
import JobApplicants from './jobapplication/jobapplicants.js';
import Staffupload from './staffbulk/staffupload.js';
import Cv from './cv/cv.js';
import Quickassign from './Shiftdetails/quickassign.js';
import Attendancedetails from './attendance/attendancedetails.js';
import Shiftassign from './Shiftdetails/assignshift.js';
import Attendancemanagement from './attendance/attendancemanagement.js';
// import Assigntest from './Shiftdetails/assigntest';
import RegionBranch from './Region&Branch/BranchesRegions.js';
import Jobpost from './jobs/jobposting';
import Fixedshift from './Shiftdetails/fixedshift';
import JobApplicant from './jobs/jobapplicant.js';
$(function () {
  $("body").on('click', ".nav-control", function () {

    $('#main-wrapper').toggleClass("menu-toggle");

    $(".hamburger").toggleClass("is-active");
    $('.sidebar').toggleClass("active");
    $('.header').toggleClass("active");
    $('.content-wrap').toggleClass("active");


  });

})


$(function () {

  /*expend and collapse*/
  $(".hi").on('click', function () {

    $('.mcollapse').toggleClass("is-clicked");
  });

})

$(function () {
  $('.mm-collapse').hide()
  $('.collapse').hide()
  $('body').on('click', '.hi', function () {
    $(this).find('.mm-collapse').slideToggle(1000);
    $(".rows").not(".mm-collapse").slideUp();
    $(".fi ").removeClass("down");
    $(this).find('.hi').toggleClass("down");


  });

  $('body').on('click', '.fi', function () {
    $(this).find('.collapse').slideToggle(1000);
    $(".rows").not(".collapse").slideUp();
    $(".hi").removeClass("down");
    $(this).find('.fi').toggleClass("down");


  });



});




// $(document).ready(function () {
//   $('.mm-collapse').hide()
//   $('li').on('click', function () {
//     $(this).find('ul').slideToggle(1000);
//     $(this).find('.sidebar-collapse-icon ').toggleClass("down"); 
//     return false;
//   });
//   $('.content').hide();
//   $('.submenu').click(function () {
//     $('.content:visible').hide('fast');
//     $('#' + $(this).data('content')).show('fast');
//   });
// });




//Init stuff here


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
        {/* <BrowserRouter> */}
        <BrowserRouter basename="/ddcHR">
      <Routes>
        <Route index element={<Login />} />
        <Route path="test" element={<App />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="userlist" element={<Usercontroller />} />
        <Route path="stafflist" element={<Staffcontroller />} />
        <Route path="settings" element={<Settingscontroller />} />
        <Route path="joblist" element={<Joblist />} />
        <Route path="AddStaff" element={<AddStaff />} />
        <Route path="Editstaff/:staff_id" element={<Editstaff />} />
        <Route path="BranchList" element={<Branchlist />} />
        <Route path="addjob" element={<Jobposting />} />
        <Route path="addbranch" element={<AddBranch />} />
        <Route path="addbranch" element={<AddBranch />} />
        <Route path="EditBranch/:branch_id" element={<Editbranch />} />
        <Route path="editjob/:ddcrecruitmentposting_id" element={<Editjobposting />} />
        <Route path='summernote' element={<Summernote />} />
        <Route path="myleaveapplication" element={<MyLeavelist />} />
        <Route path="listleave" element={<Leavelist />} />
        <Route path='leavesettings' element={<LeaveSettings />} />
        <Route path='addleavesettings' element={<AddLeaveSettings />} />
        <Route path='calendar' element={<HolidayCalender />} />
        <Route path='leavepolicy' element={<LeavePolicy />} />
        <Route path='addleavepolicy' element={<AddLeavePolicy />} />
        <Route path='editleavepolicy/:leavepolicy_num' element={<EditLeavePolicy />} />
        <Route path='leaveassignment' element={<Leaveassignment />} />
        <Route path='leaveassignmentlist' element={<Leaveassignmentlist />} />
        <Route path='leaveassignmentedit/:leaveassign_id' element={<EditLeaveassignment />} />
        <Route path='leaveapply' element={<Leaveapply />} />
        <Route path='leaveapplyadd' element={<Leaveapplyadd />} />
        <Route path='EmailRestAPI' element={<EmailRestAPI />} />
        <Route path='leaveapproves' element={<Leaveapproves />} />
        <Route path='leavecontrolpanel' element={<Leavecontrolpanel />} />
        <Route path='leavelevelsetup' element={<Leavelevelsetup />} />
        <Route path='shiftreq' element={<Shiftreq />} />
        <Route path='shiftaprvl' element={<Shiftaprvl />} />
        <Route path='shiftlist' element={<Shiftlist />} />
        <Route path='Addshift' element={<Adddailyshift />} />
        <Route path='shiftassignment' element={<Shiftassignment />} />
        <Route path='editshiftassignment/:staff_id' element={<Editshiftassignment />} />
        <Route path='editinterassignment/:staff_id' element={<Editinterassignment />} />
        <Route path='editintraassignment/:staff_id' element={<Editintraassignment />} />
        <Route path='departmentlist' element={<Departmentlist />} />
        <Route path='adddepartment' element={<Deptposting />} />
        <Route path="editdepartment/:dept_id" element={<Editdepartment />} />
        <Route path='autologout' element={<AutoLogout />} />
        <Route path='programs' element={<Programs />} />
        <Route path='menu' element={<Menu />} />
        <Route path='unauthorized' element={<Unauthorized />} />
        <Route path="shifttool" element={<Shifttool />} />
        <Route path="Addshift" element={<Adddailyshift />} />
        <Route path="AddIntershift" element={<Addintershift />} />
        <Route path="AddIntrashift" element={<Addintrashift />} />
        <Route path="attendance" element={<Attendancelist />} />
        <Route path="holidays" element={<Holidays />} />
        <Route path="punchly" element={<Punchly />} />
        <Route path="face-kiosk" element={<FaceKiosk />} />
        <Route path="report" element={<AttendanceReport />} />
        <Route path="jobapplicants" element={<JobApplicants />} />
        <Route path="staffupload" element={<Staffupload />} />
        <Route path="cv" element={<Cv />} />
        <Route path='quickassign' element={<Quickassign />} />
        <Route path="attendancedetails" element={<Attendancedetails />} />
        <Route path="shiftassign" element={<Shiftassign />} />
                <Route path="attendancemanagement" element={<Attendancemanagement />} />
                {/* <Route path="assigntest" element={<Assigntest />} /> */}
                <Route path="regionbranch" element={<RegionBranch />} />
                <Route path="jobposting" element={< Jobpost />} />
                <Route path="fixedshift" element={< Fixedshift />} />
                <Route path="jobapplicant" element={< JobApplicant />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
